import { registerPlugin } from '@capacitor/core';

import { GestureShakePluginInterface } from './definitions';
import { CAPACITOR_GESTURE_SHAKE_PLUGIN } from '../pluginConstants';

const GestureShakePlugin = registerPlugin<GestureShakePluginInterface>(CAPACITOR_GESTURE_SHAKE_PLUGIN);

export * from './definitions';
export { GestureShakePlugin };
